import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { DataExtractionService } from './api/dataExtraction.service';
import { ItemService } from './api/item.service';
import { ItemCategoryService } from './api/itemCategory.service';
import { ItemMasterDataNotificationsService } from './api/itemMasterDataNotifications.service';
import { ItemsForValidationService } from './api/itemsForValidation.service';
import { ItemsUnitOfMeasuresForValidationService } from './api/itemsUnitOfMeasuresForValidation.service';
import { ItemsUnitOfMeasuresVerifiedService } from './api/itemsUnitOfMeasuresVerified.service';
import { ItemsVerifiedService } from './api/itemsVerified.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    DataExtractionService,
    ItemService,
    ItemCategoryService,
    ItemMasterDataNotificationsService,
    ItemsForValidationService,
    ItemsUnitOfMeasuresForValidationService,
    ItemsUnitOfMeasuresVerifiedService,
    ItemsVerifiedService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
